import React, { Fragment } from "react";

import Header from "./Header";
import Footer from "./Footer";

import "../sass/main.scss";

const Layout = ({
  // location,
  // title,
  children,
}: {
  // location: Location;
  // title: string;
  children: React.ReactNode;
}) => (
  <Fragment>
    <Header />
    <main>{children}</main>
    <Footer />
  </Fragment>
);

export default Layout;
